import React from "react";
import {
  Button,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useQuiltTime } from "./timeContext";
import { fromDateTimeLocalValueInTimeZone, toDateTimeLocalValueInTimeZone } from "./timeUtils";

const AS_OF_TIME_ZONE = "America/New_York";

export default function AsOfControl() {
  const {
    asOfEnabled,
    asOfDate,
    liveEnabled,
    filterMode,
    rangeStart,
    rangeEnd,
    setAsOfEnabled,
    setAsOfDate,
    setLiveEnabled,
    setFilterMode,
    setRangeStart,
    setRangeEnd,
    setRangeToNextWeek,
    setRangeToNextMonth,
    setAsOfNow,
  } = useQuiltTime();

  return (
    <Stack spacing={1} sx={{ p: 1, border: "1px solid #e2e8f0", borderRadius: 1.5, background: "#fff" }}>
      <Typography variant="subtitle2" fontWeight={700}>Time Axis</Typography>
      <TextField
        select
        size="small"
        label="Mode"
        value={asOfEnabled ? filterMode : "off"}
        onChange={(event) => {
          const next = event.target.value;
          if (next === "off") {
            setAsOfEnabled(false);
            return;
          }
          setAsOfEnabled(true);
          setFilterMode(next);
        }}
      >
        <MenuItem value="off">Off</MenuItem>
        <MenuItem value="asOf">As-of</MenuItem>
        <MenuItem value="range">Range</MenuItem>
      </TextField>

      {asOfEnabled && filterMode === "asOf" && (
        <>
          <TextField
            size="small"
            type="datetime-local"
            label="As-of datetime (EST/EDT)"
            value={toDateTimeLocalValueInTimeZone(asOfDate, AS_OF_TIME_ZONE)}
            onChange={(event) => {
              const next = fromDateTimeLocalValueInTimeZone(event.target.value, AS_OF_TIME_ZONE);
              if (!next) return;
              setAsOfDate(next);
              setLiveEnabled(false);
            }}
            InputLabelProps={{ shrink: true }}
          />
          <Stack direction="row" spacing={1}>
            <Button size="small" variant="outlined" onClick={setAsOfNow}>Now</Button>
            <Button
              size="small"
              variant="outlined"
              onClick={() => setLiveEnabled((prev) => !prev)}
            >
              {liveEnabled ? "Pause" : "Live"}
            </Button>
          </Stack>
        </>
      )}

      {asOfEnabled && filterMode === "range" && (
        <>
          <TextField
            size="small"
            type="datetime-local"
            label="Range start (EST/EDT)"
            value={toDateTimeLocalValueInTimeZone(rangeStart, AS_OF_TIME_ZONE)}
            onChange={(event) => {
              const next = fromDateTimeLocalValueInTimeZone(event.target.value, AS_OF_TIME_ZONE);
              if (!next) return;
              setRangeStart(next);
            }}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            size="small"
            type="datetime-local"
            label="Range end (EST/EDT)"
            value={toDateTimeLocalValueInTimeZone(rangeEnd, AS_OF_TIME_ZONE)}
            onChange={(event) => {
              const next = fromDateTimeLocalValueInTimeZone(event.target.value, AS_OF_TIME_ZONE);
              if (!next) return;
              setRangeEnd(next);
            }}
            InputLabelProps={{ shrink: true }}
          />
          <Stack direction="row" spacing={1}>
            <Button size="small" variant="outlined" onClick={setRangeToNextWeek}>Next week</Button>
            <Button size="small" variant="outlined" onClick={setRangeToNextMonth}>Next month</Button>
          </Stack>
        </>
      )}
    </Stack>
  );
}
